import * as React from "react";
import {
  EditButton,
  EmailField,
  ReferenceField,
  Show,
  ShowButton,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useRecordContext,
} from "react-admin";

const UserShowActions = (props) => {
  const record = useRecordContext();

  return (
    <TopToolbar {...props}>
      <ShowButton
        to={{ pathname: `/organisations/${record?.organisationId}/show` }}
        label="Organisation"
      />
      <EditButton record={record} />
    </TopToolbar>
  );
};

export const UserShow = (props) => (
  <Show {...props} actions={<UserShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <EmailField source="email" />
      <TextField source="role" />
      <ReferenceField
        source="userData.occupationId"
        reference="occupations"
        label="Job Role"
        link={false}
        emptyText="—"
      >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField
        source="organisationId"
        reference="organisations"
        label="Organisation"
        link="show"
        emptyText="—"
      >
        <TextField source="name" />
      </ReferenceField>
    </SimpleShowLayout>
  </Show>
);
